import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.900',
        color: 'white',
        textAlign: 'center',
        py: 1.5,
      }}
    >
      <Typography variant="body2">&copy; 2026 Jordan Webb. All rights reserved.</Typography>
    </Box>
  );
};

export default Footer;
